import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    checkbox1,
    fullName1,
    taxId1,
    identity,
    identity2,
    national,
    address,
    district,
    province,
    taxAgencyName,
    taxAgencyId,
    makeIn,
    dateMakeIn,
    dateAccepted,
    fullName2,
    taxId2,
    national2,
    address2,
    district2,
    province2,
    phone,
    fax,
    email,
    checkbox2,
    checkbox3,
    checkbox4,
    certificateProperty,
    certificatePropertyByWho,
    certificatePropertyDate,
    organizationInfo,
    organizationName,
    taxId3,
    district3,
    province3,
    address3,
    phone2,
    fax2,
    email2,
    amount1,
    amount2,

    certificate,
    signer,
    fullName,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [amount1.name]: Yup.string().required(amount1.errorMsg),
  [amount2.name]: Yup.string().required(amount2.errorMsg),
  [organizationName.name]: Yup.string().required(organizationName.errorMsg),
  [certificatePropertyByWho.name]: Yup.string().required(certificatePropertyByWho.errorMsg),
  [certificatePropertyDate.name]: Yup.number().required(certificatePropertyDate.errorMsg),
  [certificateProperty.name]: Yup.string().required(certificateProperty.errorMsg),
  [organizationInfo.name]: Yup.string().required(organizationInfo.errorMsg),
  [identity.name]: Yup.string().required(identity.errorMsg),
  [identity2.name]: Yup.string().required(identity2.errorMsg),
  [national.name]: Yup.string().required(national.errorMsg),
  [national2.name]: Yup.string().required(national2.errorMsg),
  [makeIn.name]: Yup.string().required(makeIn.errorMsg),
  [dateMakeIn.name]: Yup.number().required(dateMakeIn.errorMsg),
  [dateAccepted.name]: Yup.number().required(dateAccepted.errorMsg),
  [organizationName.name]: Yup.string().required(fullName.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [address2.name]: Yup.string().required(address2.errorMsg),
  [address3.name]: Yup.string().required(address3.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [district2.name]: Yup.string().required(district2.errorMsg),
  [district3.name]: Yup.string().required(district3.errorMsg),
  [province2.name]: Yup.string().required(province2.errorMsg),
  [province3.name]: Yup.string().required(province3.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [checkbox1.name]: Yup.string().required(checkbox1.errorMsg),
  [checkbox2.name]: Yup.string().required(checkbox2.errorMsg),
  [checkbox3.name]: Yup.string().required(checkbox3.errorMsg),
  [checkbox4.name]: Yup.string().required(checkbox4.errorMsg),
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [fax.name]: Yup.string().optional(),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [email2.name]: Yup.string().required(email.errorMsg).email(email2.invalidMsg),
  [fax2.name]: Yup.string().optional(),
  [phone2.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone2.invalidMsg)
    .required(phone2.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId1.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId1.errorMsg),
  [taxId3.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId3.invalidMsg)
    .required(taxId3.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [fullName1.name]: Yup.string().required(fullName1.errorMsg),
  [fullName2.name]: Yup.string().required(fullName2.errorMsg),
});

export default validation;
